export default __webpack_public_path__ + "static/media/google.efa560d3.svg";